"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSeatUpgrade = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _requestNotificationsApi = require("ui-addon-upgrades/_core/common/api/requestNotificationsApi");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _wrapWithErrorMonitoring = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring"));

var requestSeatUpgrade = (0, _wrapWithErrorMonitoring.default)('requestSeatUpgrade', function (upgradeData) {
  var seatedProductOwned = upgradeData.seatedProductOwned,
      upgradeProduct = upgradeData.upgradeProduct;
  var productProperties = _ImmutableMerchandiseIdMap.default[seatedProductOwned];

  var defaultName = _I18n.default.text('upgrades.products.default');

  var productName = productProperties ? productProperties.productName || defaultName : defaultName;
  return (0, _requestNotificationsApi.sendRequestAccessNotification)(productName).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request seat succeeded',
      merchandiseId: seatedProductOwned,
      upgradeProduct: upgradeProduct
    });
    return {
      hasError: false
    };
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request seat failed',
      merchandiseId: seatedProductOwned,
      upgradeProduct: upgradeProduct
    });

    if (window.Raven) {
      window.Raven.captureMessage('Request seat notification failed', {
        extra: {
          error: e
        }
      });
    }

    return {
      hasError: true
    };
  });
});
exports.requestSeatUpgrade = requestSeatUpgrade;